
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AnswerSetDialogModule } from './components/dialogs/answer-set-dialog/answer-set-dialog.module';
import { ButtonModule } from './components/button/button.module';
import { CellRenderersModule } from './components/cell-renderers/cell-renderers.module';
import { CheckboxModule } from './components/form/checkbox/checkbox.module';
import { CheckboxWrapperModule } from './components/formly-custom-templates/custom-field-checkbox/checkbox-wrapper.module';
import { ConfirmDialogModule } from './components/dialogs/confirm-dialog/confirm-dialog.module';
import { GuidanceNotesEditorDialogModule } from './components/dialogs/guidance-notes-editor-dialog/guidance-notes-editor-dialog.module';
import { CustomFieldCheckboxModule } from './components/formly-custom-templates/custom-field-checkbox/custom-field-checkbox.module';
import { CustomFieldDatePickerModule } from './components/formly-custom-templates/custom-field-date-picker/custom-field-date-picker.module';
import { CustomFieldHealthAndSafetyResponsibilitiesModule } from './components/formly-custom-templates/custom-field-health-and-safety-responsibilities/custom-field-health-and-safety-responsibilities.module';
import { CustomFieldInputModule } from './components/formly-custom-templates/custom-field-input/custom-field-input.module';
import { CustomFieldRadioModule } from './components/formly-custom-templates/custom-field-radio/custom-field-radio.module';
import { CustomFieldTextareaModule } from './components/formly-custom-templates/custom-field-textarea/custom-field-textarea.module';
import { CustomFieldResponsibilityListModule } from './components/formly-custom-templates/custom-field-responsibility-list/custom-field-responsibility-list.module';
import { DataGridModule } from './components/data-grid/data-grid.module';
import { DirectivesModule } from './directives/directives.module';
import { EditorDialogModule } from './components/dialogs/editor-dialog/editor-dialog.module';
import { EnvironmentBannerModule } from './components/environment-banner/environment-banner.module';
import { FormFieldCrudControlsModule } from './components/formly-custom-templates/form-field-crud-controls/form-field-crud-controls.module';
import { GlobalFooterModule } from './components/global-footer/global-footer.module';
import { GlobalHeaderModule } from './components/global-header/global-header.module';
import { HeaderModule } from './components/header/header.module';
import { IconModule } from './components/icon/icon.module';
import { InputModule } from './components/form/input/input.module';
import { InsertQuestionDialogModule } from './components/dialogs/editor-dialog/dialogs/insert-question-dialog/insert-question-dialog.module';
import { LinkModule } from './components/link/link.module';
import { LoaderModule } from './components/loader/loader.module';
import { NotificationModule } from './components/notification/notification.module';
import { RadioWrapperModule } from './components/formly-custom-templates/custom-field-radio/radio-wrapper.module';
import { RouterTabsetModule } from './components/router-tabset/router-tabset.module';
import { ScrollToTopModule } from './components/scroll-to-top/scroll-to-top.module';
import { SelectModule } from './components/form/select/select.module';
import { TabNavModule } from './components/tab-nav/tab-nav.module';
import { TabSetModule } from './components/tab-set/tab-set.module';
import { ValidateTagValidator } from './validators/validateTag.validator';
import { ValidatePastDateValidator } from './validators/validatePastDate.validator';
import { DatePickerModule } from './components/form/date-picker/date-picker.module';
import { PipesModule } from "./pipes/pipes.module";

export { AnswerSetDialogModule } from './components/dialogs/answer-set-dialog/answer-set-dialog.module';
export { ButtonModule } from './components/button/button.module';
export { CellRenderersModule } from './components/cell-renderers/cell-renderers.module';
export { CheckboxModule } from './components/form/checkbox/checkbox.module';
export { CheckboxWrapperModule } from './components/formly-custom-templates/custom-field-checkbox/checkbox-wrapper.module';
export { ConfirmDialogModule } from './components/dialogs/confirm-dialog/confirm-dialog.module';
export { GuidanceNotesEditorDialogModule } from './components/dialogs/guidance-notes-editor-dialog/guidance-notes-editor-dialog.module';
export { CustomFieldCheckboxModule } from './components/formly-custom-templates/custom-field-checkbox/custom-field-checkbox.module';
export { CustomFieldDatePickerModule } from './components/formly-custom-templates/custom-field-date-picker/custom-field-date-picker.module';
export { CustomFieldHealthAndSafetyResponsibilitiesModule } from './components/formly-custom-templates/custom-field-health-and-safety-responsibilities/custom-field-health-and-safety-responsibilities.module';
export { CustomFieldInputModule } from './components/formly-custom-templates/custom-field-input/custom-field-input.module';
export { CustomFieldRadioModule } from './components/formly-custom-templates/custom-field-radio/custom-field-radio.module';
export { CustomFieldTextareaModule } from './components/formly-custom-templates/custom-field-textarea/custom-field-textarea.module';
export { CustomFieldResponsibilityListModule } from './components/formly-custom-templates/custom-field-responsibility-list/custom-field-responsibility-list.module';
export { DataGridModule } from './components/data-grid/data-grid.module';
export { DirectivesModule } from './directives/directives.module';
export { EditorDialogModule } from './components/dialogs/editor-dialog/editor-dialog.module';
export { EnvironmentBannerModule } from './components/environment-banner/environment-banner.module';
export { FormFieldCrudControlsModule } from './components/formly-custom-templates/form-field-crud-controls/form-field-crud-controls.module';
export { GlobalFooterModule } from './components/global-footer/global-footer.module';
export { GlobalHeaderModule } from './components/global-header/global-header.module';
export { HeaderModule } from './components/header/header.module';
export { IconModule } from './components/icon/icon.module';
export { InputModule } from './components/form/input/input.module';
export { InsertQuestionDialogModule } from './components/dialogs/editor-dialog/dialogs/insert-question-dialog/insert-question-dialog.module';
export { LinkModule } from './components/link/link.module';
export { LoaderModule } from './components/loader/loader.module';
export { NotificationModule } from './components/notification/notification.module';
export { RadioWrapperModule } from './components/formly-custom-templates/custom-field-radio/radio-wrapper.module';
export { RouterTabsetModule } from './components/router-tabset/router-tabset.module';
export { ScrollToTopModule } from './components/scroll-to-top/scroll-to-top.module';
export { SelectModule } from './components/form/select/select.module';
export { TabNavModule } from './components/tab-nav/tab-nav.module';
export { TabSetModule } from './components/tab-set/tab-set.module';
export { ValidateTagValidator } from './validators/validateTag.validator';
export { ValidatePastDateValidator } from './validators/validatePastDate.validator';
export { DatePickerModule } from './components/form/date-picker/date-picker.module';
export { PipesModule } from "./pipes/pipes.module";

const sharedModules = [
  AnswerSetDialogModule,
  ButtonModule,
  CellRenderersModule,
  CheckboxModule,
  CheckboxWrapperModule,
  ConfirmDialogModule,
  GuidanceNotesEditorDialogModule,
  CustomFieldCheckboxModule,
  CustomFieldDatePickerModule,
  CustomFieldHealthAndSafetyResponsibilitiesModule,
  CustomFieldInputModule,
  CustomFieldRadioModule,
  CustomFieldTextareaModule,
  CustomFieldResponsibilityListModule,
  DataGridModule,
  DirectivesModule,
  EditorDialogModule,
  EnvironmentBannerModule,
  FormFieldCrudControlsModule,
  GlobalFooterModule,
  GlobalHeaderModule,
  HeaderModule,
  IconModule,
  InputModule,
  InsertQuestionDialogModule,
  LinkModule,
  LoaderModule,
  NotificationModule,
  RadioWrapperModule,
  RouterTabsetModule,
  ScrollToTopModule,
  SelectModule,
  TabNavModule,
  TabSetModule,
  DatePickerModule,
  PipesModule
];

@NgModule({
  imports: [
    CommonModule,
    sharedModules
  ],
  exports: [sharedModules],
  providers: [
    ValidateTagValidator,
    ValidatePastDateValidator
  ]
})

export class SharedModule { }
